import React from "react"
import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"
import VerticalLayout from "components/VerticalLayout"
import HorizontalLayout from "components/HorizontalLayout"
import { layoutTypes } from "../../constants/layout"

import MainLoader from "components/Loader/MainLoader"
import { useGetMyProfileQuery } from "store/features/user/userManagementApi"

const Authmiddleware = ({ children }) => {
  const layoutType = "vertical"
  const Layout =
    layoutType === layoutTypes.HORIZONTAL ? HorizontalLayout : VerticalLayout

  // ✅ Get current auth state from redux
  const auth = useSelector(state => {
    return state.auth
  })
  const userId = auth?.user?.id

  // ✅ Fetch latest profile using RTK Query
  const { data: profile, isLoading } = useGetMyProfileQuery(userId, {
    skip: !userId,
  })

  if (isLoading) return <MainLoader />

  // ✅ Check if user is logged in and profile matches
  if (profile?.personal_email === auth.user?.email) {
    return <Layout>{children}</Layout>
  }

  // ❌ If not authenticated → redirect to login
  return <Navigate to="/login" replace />
}

export default Authmiddleware
